import React, {Fragment} from 'react';

import NoDataImg from "../assets/utils/images/no-datafound.png";

export default function NoRecord(props){

    let msg = props.msg != undefined ? props.msg : "No Data Found."

    return (
        <Fragment>
            <div className={`no-datafound`}>
                <img className={'no-data-img'} src={NoDataImg} />
                <h2>No data found</h2>
                <p>You don’t have any records to view.</p>
            </div>
        </Fragment>
    )
}
